<template>
    <v-container fluid>
        <v-row>
            <h1 style="margin-left: 20px;">帳號設置</h1>
            <v-btn @click="account_dialog_title='新增使用者'; edit_account(false)" large color="primary" class="ml-3" style="font-size: 18px;">新增使用者</v-btn>
        </v-row>

        <v-row justify="center" class="mt-3">
            <v-col cols="12" sm="11">
                <v-data-table :headers="headers" :items="table_data" hide-default-footer class="elevation-1">
                    <template v-slot:item.index="{ item }">
                        {{table_data.findIndex(items => { return items.name == item.name})+1}}
                    </template>
                    <template v-slot:item.right="{item}">
                        <v-row>
                            <v-col cols="12" sm="4" v-for="(s_right, idx) in right_list" :key="idx">
                                <v-checkbox v-model="item[s_right.type]" class="input_30測試0" :label='s_right.label' disabled></v-checkbox>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-slot:item.set="{item}">
                        <v-btn @click="account_dialog_title='編輯使用者'; edit_user=item.name; edit_account(true);" class="ml-3" color="primary">編輯</v-btn>
                        <v-btn @click="open_delete(item.name)" class="ml-3" color="error">刪除</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog v-model="account_dialog" max-width="600px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">{{account_dialog_title}}
                    <v-spacer/>
                    <v-icon @click="account_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-text class="mt-4 pa-6">
                    <v-text-field v-model="new_user.name" label="名稱" outlined></v-text-field>
                    <v-text-field v-model="new_user.account" label="帳號" outlined></v-text-field>
                    <v-text-field v-model="new_user.password" label="密碼" outlined></v-text-field>
                    <v-text-field v-model="new_user.check_password" label="確認密碼" outlined></v-text-field>
                    <v-row>
                        <v-col cols="12" sm="4" v-for="(s_right, idx) in right_list" :key="idx">
                            <v-checkbox v-model="input_account[s_right.type]" class="input_300" :label='s_right.label'></v-checkbox>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pl-6 pr-6" justify="center">
                    <v-row justify="center">
                        <v-btn color="success" @click="submit(); account_dialog = false;" block>送出</v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="delete_dialog" max-width="300px" persistent>
            <v-card style="overflow: hidden;">
                <v-card-title class="headline grey lighten-2">確定刪除{{delete_dialog_account}}?
                    <v-spacer/>
                    <v-icon @click="delete_dialog=false">mdi-close</v-icon>
                </v-card-title>
                <v-card-actions>        
                    <v-col>
                        <v-btn @click="delete_dialog = false;" block>取消</v-btn>
                    </v-col>   
                    <v-col>
                        <v-btn color="error" @click="delete_account(delete_index); delete_dialog = false;" block>確定</v-btn>       
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
var host_url = process.env.VUE_APP_HOST_URL 
export default {
    data(){
        return {
            page: 0,
            account_dialog: false,
            account_dialog_title: "",
            headers: [
                {text: '編號', align: 'center', value: 'index', width: 60, sortable: false},
                {text: '名稱', align: 'center', value: 'name', width: 200, sortable: false},
                {text: '權限', align: 'center', value: 'right', width: 400, sortable: false},
                {text: '操作', align: 'center', value: 'set', width: 200, sortable: false},
            ],
            input_account: {
                list_right: true,
                question_right: false,
                line_right: true,
            },
            test_table: [],
            table_data: [
                {   
                    name: '荔枝智慧',
                    list_right: true,
                    question_right: false,
                    line_right: true,
                },
                {
                    name: '愛承諾',
                    list_right: true,
                    question_right: true,
                    line_right: true,
                },
                {   
                    name: '富邦產險',
                    list_right: true,
                    question_right: true,
                    line_right: false,
                },
                {   
                    name: '萬達鴻',
                    list_right: false,
                    question_right: true,
                    line_right: true,
                },
                {   
                    name: '問巴',
                    list_right: false,
                    question_right: false,
                    line_right: true,
                },
            ],
            right_list: [
                {'type': 'list_right', 'label': '名單管理'}, 
                {'type': 'question_right', 'label': '問卷管理'}, 
                {'type': 'line_right', 'label': 'LINE群發'}
            ],
            edit_status: '',
            edit_user: '',
            new_user: {
                name: '',
                account: '',
                password: '',
                check_password: '',
            },
            delete_dialog: false,
            delete_dialog_account: '',
            delete_index: '',
        }
    },
    methods: {
        get_account_list(){
            axios.get(host_url+'get_account_list')
            .then(response => {
            var tmp = response.data
            if(tmp.status == true){
                if (tmp.other_liff.length >= 30){
                    this.liffToMuchCheck = true;
                    }
                }
            })
            .catch((error) =>{
                this.$ga.event('liff_manage', 'getliffevent', 'Error')
                console.log(error);
            });
        },
        edit_account(edit_status){
            if(edit_status == true){
                let data = this.table_data.find(item => {
                    return item.name == this.edit_user;
                });
                console.log(data)
                this.new_user = {
                    name: data.name,
                    account: 'test',
                    password: 'tes',
                    check_password: 'tes'
                }
            }
            this.account_dialog = true
            this.edit_status = edit_status
            
        },
        submit(){
            if(this.edit_status == false){
                // TODO
                // axios.post(host_url+'').then()
                this.addUser()
            }
            else{
                this.editUser()
            }
        }, 
        addUser(){
            this.table_data.push({
                "name": this.new_user.name,
                "list_right": this.input_account.list_right,
                "question_right": this.input_account.question_right,
                "line_right": this.input_account.line_right,
            })
            this.init_user()
        },
        editUser(){
            let index = this.table_data.findIndex(item => {
                    return item.name == this.edit_user;
                });
            this.$set(this.table_data, index, {
                "name": this.new_user.name,
                "list_right": this.input_account.list_right,
                "question_right": this.input_account.question_right,
                "line_right": this.input_account.line_right,
            })
        },
        delete_account(){
            this.table_data.splice(this.delete_index, 1);
        },
        open_delete(name){
            this.delete_dialog_account = name;
            this.delete_dialog = true;
            this.delete_index = this.table_data.findIndex(item => {
                return item.name == name;
            });
        },
        // 初始化新增使用者
        init_user(){
            this.new_user={
                name: '',
                account: '',
                password: '',
                check_password: '',
            }
        },
    },
}
</script>

<style lang="scss" scoped>

::v-deep .input_300{
    max-width: 300px;
}

</style>